import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

interface empCompany {
  logo: string;
}

const initialState: empCompany = {
  logo: "",
};
const employeeCompanySlice = createSlice({
  name: "employeeCompany",

  initialState,
  reducers: {
    setEmployeeCompanyData: (
      state: empCompany,
      action: PayloadAction<empCompany>
    ) => {
      const payload = action.payload;
      state.logo = payload.logo;
    },
    removeEmployeeCompanyData: (state: any) => {
      state.employeeCompany = {};
    },
  },
});

export const { setEmployeeCompanyData, removeEmployeeCompanyData } =
  employeeCompanySlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default employeeCompanySlice.reducer;
